<template>
  <div class="container">
    <div class="row mb-5 pb-5 cart-content">
      <div class="col-12">
        <div class="main_title version_2">
          <span><em></em></span>
          <h2 class="title-giohang">Giỏ hàng</h2>
        </div>
      </div>
      <div class="col-md-12">
        <div class="list_home list-page-cart">
          <ul v-if="getterListItemInCart.length > 0">
            <li v-for="(item,index) in getterListItemInCart">
              <div class="row col-12 item-in-cart">
                <figure class="col-md-2 col-4" style="padding: 0;margin-bottom: 0">
                  <img
                    :src="getPathProduct(item.product.image.path)"
                    :data-src="getPathProduct(item.product.image.path)"
                    alt="" class="lazy loaded img-item-cart" data-was-processed="true">
                </figure>
                <div class="col-8 info-item-cart">
                  <em>{{item.merchant.name}}</em>
                  <h4 class="name-item-cart" style="color: #589442">{{item.product.name}}</h4>
                  <h5 class="price-item-cart">{{convertCurrency(item.product.price)}} </h5>
                </div>
                <div class="col-md-2 qty-item-cart">
                  <ul class="d-flex align-items-center">
                    <li style="width: auto">
                      <div class="score" @click="item.qty > 1 ? changeQty(item,index,'unplus') : 'javascript:void(0)'"><strong>-</strong></div>
                    </li>
                    <li style="width: 50px" class="text-center">
                      <div class="" ><h5 style="margin-bottom: 0;padding: 4px 0">{{item.qty}}</h5></div>
                    </li>
                    <li style="width: auto">
                      <div class="score" @click="changeQty(item,index,'plus')"><strong>+</strong></div>
                    </li>
                    <div class="icon-rm-item" @click="removeItemInCart(index)">
                      <i style="font-size: 22px;cursor: pointer" class="icon_trash_alt"></i>
                    </div>
                  </ul>

                </div>
              </div>
            </li>
          </ul>
          <h5 v-if="getterListItemInCart.length == 0">
            Giỏ hàng trống !
          </h5>
        </div>
      </div>
      <div v-if="getterListItemInCart.length > 0" class="col-12 row  align-items-baseline justify-content-between mt-4 total-cart">
        <div class="d-flex" style="justify-content: center;align-items: center">
          <h5 class="txt-total-num-price-cart">Tổng ({{ countItemCart() }}) : </h5>
          <h3 class="total-num-price-cart" style="padding-left: 20px;color: darkblue">{{ totalPriceCart()}}</h3>
        </div>
        <router-link to="/checkout" class="btn_1 btn-to-checkout">Đặt ngay</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderShop from "./Header-Shop";
import {mapActions, mapGetters} from "vuex";
import {isEmptyObject} from "../helpers";
export default {
  name: "Cart",
  components: {HeaderShop},
  computed:{
    ...mapGetters(['getterListItemInCart'])
  },
  created() {
    console.log(this.$route.name)
  },
  mounted() {
    this.$store.commit('SHOW_DROPDOWN_CART',false)
  },
  methods:{
    ...mapActions(['updateCart','removeItemCart']),
    changeQty(product,index,action){
      this.updateCart({product,index,action});
    },
    convertCurrency(x){
      return x.toLocaleString('vi-VN') + ' VNĐ'
    },
    countItemCart() {
      let totalItem = 0;
      this.getterListItemInCart.forEach(function (item) {
        totalItem += item.qty
      })
      return totalItem
    },
    totalPriceCart(){
      let totalPrice = 0;
      this.getterListItemInCart.forEach(function (item) {
        totalPrice += item.product.price * item.qty
      })
      return this.convertCurrency(totalPrice)
    },
    getPathProduct(path) {
      return !isEmptyObject(path) ? path : '/static/images/restaurant_detail_hero.jpg'
    },
    removeItemInCart(index){
      this.removeItemCart(index)
    }
  }
}
</script>

<style scoped>
.icon-rm-item{
  margin-top: -20px;
  margin-left: 20px;
}

</style>



// WEBPACK FOOTER //
// src/components/Cart.vue